<h2 mat-dialog-title>
    <span *ngIf="this.data.data?.title; else defaultTitle">{{ this.data.data?.title }}</span>
    <ng-template #defaultTitle>
        <span>{{ appService.language_dictionary.system_subscribe_table_title }}</span>
    </ng-template>
    <button
        type="button"
        class="mat-icon-button"
        (click)="close()"
        title="{{ appService.language_dictionary.system_close }}"
    >
        <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
    </button>
</h2>
<mat-dialog-content>
    <div class="crypto-pro-certificate-table-container">
        <ng-container *ngIf="emptyResult === true">
            <mat-card class="message-empty-results-block">
                {{ appService.language_dictionary.system_user_table_no_results }}
            </mat-card>
        </ng-container>
        <ng-container *ngIf="emptyResult !== true && initTable">
            <mat-table #dataMatTable="matTable" [dataSource]="dataTables.filteredData">
                <ng-container matColumnDef="created_at">
                    <mat-header-cell *matHeaderCellDef class="text-center">
                        <div>
                            <span [title]="appService.language_dictionary.system_subscribe_table_date">
                                {{ appService.language_dictionary.system_subscribe_table_date }}
                            </span>
                        </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        {{ row?.created_at | formater: 'datetime' }}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="created_by">
                    <mat-header-cell *matHeaderCellDef class="text-center">
                        <div>
                            <span [title]="appService.language_dictionary.system_user">
                                {{ appService.language_dictionary.system_user }}
                            </span>
                        </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        {{ row?.created_by }}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="owner">
                    <mat-header-cell *matHeaderCellDef class="text-left">
                        <div>
                            <span [title]="appService.language_dictionary.sign_owner">
                                {{ appService.language_dictionary.sign_owner }}
                            </span>
                        </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        {{ row?.owner }}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="roles">
                    <mat-header-cell *matHeaderCellDef class="text-center">
                        <div>
                            <span [title]="appService.language_dictionary.system_subscribe_table_role">
                                {{ appService.language_dictionary.system_subscribe_table_role }}
                            </span>
                        </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        {{ row?.roles }}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="publisher">
                    <mat-header-cell *matHeaderCellDef class="text-left">
                        <div>
                            <span [title]="appService.language_dictionary.sign_publisher">
                                {{ appService.language_dictionary.sign_publisher }}
                            </span>
                        </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        {{ row?.publisher }}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="valid_to">
                    <mat-header-cell *matHeaderCellDef class="text-left">
                        <div>
                            <span [title]="appService.language_dictionary.sign_valid_to">
                                {{ appService.language_dictionary.sign_valid_to }}
                            </span>
                        </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        {{ row?.valid_to }}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="type">
                    <mat-header-cell *matHeaderCellDef class="text-center">
                        <div>
                            <span [title]="appService.language_dictionary.system_signs_type">
                                {{ appService.language_dictionary.system_signs_type }}
                            </span>
                        </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        {{ row?.type }}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef class="text-center">
                        <div>
                            <span [title]="appService.language_dictionary.system_subscribe_table_status">
                                {{ appService.language_dictionary.system_subscribe_table_status }}
                            </span>
                        </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        {{ appService.language_dictionary.system_subscribe_file_signed }}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="sign">
                    <mat-header-cell *matHeaderCellDef class="text-center button-column">
                        <div>{{ appService.language_dictionary.system_subscribe_table_sign }}</div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row; let index = index" class="text-center button-column">
                        <button
                            mat-button
                            matSuffix
                            mat-icon-button
                            class="mat-button-icon-padding mat-button-icon-primary"
                            (click)="downloadSign(row.sign, index)"
                            title="{{ appService.language_dictionary.system_download }}"
                        >
                            <mat-icon fontSet="mdi" fontIcon="mdi-cloud-download"></mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>
                <mat-header-row
                    *matHeaderRowDef="settingsTable.displayedColumns; sticky: true"
                    class="mat-elevation-z1"
                ></mat-header-row>
                <mat-row
                    id="row-{{ index }}"
                    class="mat-elevation-z1"
                    *matRowDef="let row; columns: settingsTable.displayedColumns; let index = index"
                ></mat-row>
            </mat-table>
        </ng-container>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button type="button" class="mat-raised-button" (click)="close()">
        <span class="deti-bela-icon deti-bela-icon-close"></span>
        <span>{{ appService.language_dictionary.system_cancel }}</span>
    </button>
</mat-dialog-actions>
